// Standalone Serve Receive page: a Serve Receives By Players tab (the
// existing ServeReceiveReport) and a Serve Receive By Zones tab (new, empty
// for now). Mirrors MomentumChartPage.jsx's standalone-page pattern.
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ServeReceiveByZones from "../components/matches/ServeReceiveByZones";
import ServeReceiveReport from "../components/matches/ServeReceiveReport";
import { useLanguage } from "../context/Language/LanguageContext";

// Persists which tab the user was on across navigating away and back (e.g.
// clicking a chart zone to view a playlist, or Close then reopening Serve
// Receives) so they return to the same report instead of always Players.
const kActiveTabKey = "ServeReceiveReportActiveTab";

function ServeReceiveReportPage() {
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const { matches, team, selectedGame, selectedTeam } = location.state ?? {};
  const [activeTab, setActiveTab] = useState(() => {
    const stored = parseInt(localStorage.getItem(kActiveTabKey), 10);
    return stored === 1 ? 1 : 0;
  });

  const selectTab = (tab) => {
    setActiveTab(tab);
    localStorage.setItem(kActiveTabKey, String(tab));
  };

  if (!matches) {
    return (
      <div className="alert alert-error m-4">
        <span>{t("This report isn't supported on this browser yet — please use Safari.")}</span>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between px-2 py-1">
        <h2 className="font-bold text-lg">{t("Serve Receives")}</h2>
        <button className="btn btn-sm" onClick={() => navigate(-1)}>
          {t("Close")}
        </button>
      </div>

      <div role="tablist" className="tabs tabs-boxed mx-2 mb-2 w-fit">
        <button
          type="button"
          role="tab"
          className={"tab" + (activeTab === 0 ? " tab-active" : "")}
          onClick={() => selectTab(0)}
        >
          {t("Serve Receives By Players")}
        </button>
        <button
          type="button"
          role="tab"
          className={"tab" + (activeTab === 1 ? " tab-active" : "")}
          onClick={() => selectTab(1)}
        >
          {t("Serve Receive By Zones")}
        </button>
      </div>

      {activeTab === 0 ? (
        <ServeReceiveReport
          matches={matches}
          team={team}
          selectedGame={selectedGame}
          selectedTeam={selectedTeam}
        />
      ) : (
        <ServeReceiveByZones
          matches={matches}
          team={team}
          selectedGame={selectedGame}
          selectedTeam={selectedTeam}
        />
      )}
    </div>
  );
}

export default ServeReceiveReportPage;
